import { jsxs, jsx } from "react/jsx-runtime";
import { Box, TextButton, List, Anchor } from "@zillow/constellation-10";
import { IconChevronDownFilled } from "@zillow/constellation-icons";
import { yieldCallback } from "@zillow/yield-callback";
import { useState } from "react";
const submenuHeaderStyles = {
  paddingBlock: "tight",
  paddingInline: "default"
};
const submenuHeaderIconStyles = {
  color: "text.accent.brand.hero"
};
const submenuListStyles = {
  // v10 List.Root sets `color: List.label` as a base style, overriding parent
  // color inheritance. Force inherit so a footer inside a colored Group (e.g.
  // white text on a dark background) still renders correctly — v8 List set no
  // color of its own.
  color: "inherit",
  marginTop: "0",
  marginBottom: "0"
};
const submenuListItemStyles = {
  marginTop: "0",
  marginBottom: "0"
};
const SEOFooterSubmenu = ({
  label,
  links = []
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return /* @__PURE__ */ jsxs(Box, { children: [
    /* @__PURE__ */ jsxs(TextButton.Root, { tone: "neutral", textStyle: "body-bold", onClick: yieldCallback(() => setIsOpen(!isOpen)), css: submenuHeaderStyles, children: [
      /* @__PURE__ */ jsx(TextButton.Label, { children: label }),
      /* @__PURE__ */ jsx(TextButton.Icon, { size: "sm", css: submenuHeaderIconStyles, children: /* @__PURE__ */ jsx(IconChevronDownFilled, {}) })
    ] }),
    isOpen && /* @__PURE__ */ jsx(List.Root, { appearance: "none", css: submenuListStyles, children: links.map((link) => /* @__PURE__ */ jsx(List.Item, { css: submenuListItemStyles, children: /* @__PURE__ */ jsx(Anchor, { href: link.src, target: link.target, children: link.label }) }, link == null ? void 0 : link.label)) })
  ] });
};
export {
  SEOFooterSubmenu as default
};
